import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import DepartmentSectionStyle3 from '../Section/DepartmentSection/DepartmentSectionStyle3';
import BannerSectionStyle6 from '../Section/BannerSection/BannerSectionStyle6';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL } from "../../helpers/api";

export default function Departments() {
  pageTitle('Departments');

  const [departmentData, setDepartmentData] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/department_data`)
      .then((res) => {
        // Assuming your API response looks like:
        // [{ dprt_id: 1, name: "Emergency Department", description: "...", status: 1 }, ...]
        const formattedData = res.data.map((dept) => ({
          iconUrl: '/images/departments/icon_1.svg', // default icon
          title: dept.name,
          subTitle: dept.description,
          href: `/departments/${dept.name}`,
          departmentId: dept.dprt_id // link to department details
        }));
        setDepartmentData(formattedData);
      })
      .catch((err) => console.error('Error fetching departments:', err));
  }, []);

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/departments/banner_bg.svg"
        imgUrl="/images/departments/doctorimg5.jpeg"
        title="Get to Know <br>Medayus Departments"
        subTitle="At Medayus, we offer a wide range of medical and healthcare services that are designed to meet your individual needs and help you achieve optimal health."
      />

      <Section bottomMd={140} bottomLg={100} bottomXl={60}>
        {/* Pass dynamic data from API */}
        <DepartmentSectionStyle3 data={departmentData} />
      </Section>

      <Section className="cs_footer_margin_0">
        <BannerSectionStyle6
          imgUrl="/images/departments/doctorimg5.jpeg"
          title="Don’t Let Your Health Take a Backseat!"
          subTitle="Schedule an appointment with one of our <br />experienced medical professionals today!"
        />
      </Section>
    </>
  );
}